import React, {Component} from 'react';
import { Form, FormControl, FormGroup, InputGroup, ControlLabel, HelpBlock, Row, Col, Button, Table } from 'react-bootstrap';
import GoogleMap from 'google-map-react';
import {IconMarker} from './Timeline';

const MAP_LAT = 48.10161;
const MAP_LNG = 11.65529;

export default class Contact extends Component {

    static defaultProps = {
        center: {lat: MAP_LAT, lng: MAP_LNG},
        zoom: 12
    };

    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="card transition-item">
                <header>
                    <h1>Kontakt</h1>
                </header>

                <Row>
                    <Col sm={6}>

                        <p>Schreiben Sie mir einfach eine Email oder rufen Sie mich direkt an. <br/>Ich freue mich auf Sie! <br/><br/></p>

                        <Table>
                            <tbody>
                                <tr>
                                    <th>Anschrift</th>
                                    <td>
                                    Annette-Kolb-Anger 13 <br/>
                                    81737 München
                                    </td>
                                </tr>
                                <tr>
                                    <th>Mobil</th>
                                    <td>0176-4852-9775</td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td><a href="mailto:kateryna.byelousova@fortepiano-unterricht.de">kateryna.byelousova@fortepiano-unterricht.de</a></td>
                                </tr>
                            </tbody>
                        </Table>

                        {/* <Form horizontal>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={2}>
                                    Full Name
                                </Col>
                                <Col sm={10}>
                                    <FormControl name="name"/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={2}>
                                    Email
                                </Col>
                                <Col sm={10}>
                                    <FormControl type="email" name="email"/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={2}>
                                    Telefon
                                </Col>
                                <Col sm={10}>
                                    <FormControl name="phone"/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Col componentClass={ControlLabel} sm={2}>
                                    Message
                                </Col>
                                <Col sm={10}>
                                    <FormControl componentClass="textarea" type="textarea" name="message" rows="10"/>
                                </Col>
                            </FormGroup>
                            <FormGroup>
                                <Button block={true} type="submit" bsStyle="default">Senden</Button>
                            </FormGroup>
                        </Form> */}
                    </Col>
                    <Col sm={6}>
                        <div className="map-container" style={{height: 600 +"px"}}>
                            <GoogleMap
                                bootstrapURLKeys={{ key: "AIzaSyCHCWGSCwsz4njw2sAZY3dcFwdxV0zv5zQ" }}
                                defaultCenter={this.props.center}
                                defaultZoom={this.props.zoom}>
                                <IconMarker
                                lat={MAP_LAT}
                                lng={MAP_LNG}>fp fp-location-pin</IconMarker>
                            </GoogleMap>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Contact.js